import React from "react";
import { Routes, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { useTabContext } from "../contexts/TabContext";
import { tabRouteElements } from "./TabRoutes";

/**
 * 每个打开的标签各自挂载一套 Routes；非当前标签用 display:none 隐藏。
 * 切换标签时不卸载页面，保留列表滚动、表单与本地状态。
 */
const TabContent = () => {
  const { tabs, activeTabId } = useTabContext();
  const browserLocation = useLocation();
  const activeTab = tabs.find((t) => t.id === activeTabId);

  if (!activeTab) return null;

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        height: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeTabId;
        const useRealLocation =
          isActive &&
          (browserLocation.pathname === tab.path ||
            (browserLocation.pathname === "/" && tab.path === "/dashboard"));

        const routesLocation = useRealLocation
          ? browserLocation
          : {
              pathname: tab.path,
              search: "",
              hash: "",
              state: null,
              key: tab.id,
            };

        return (
          <Box
            key={tab.id}
            sx={{
              display: isActive ? "flex" : "none",
              flex: 1,
              minHeight: 0,
              height: "100%",
              overflow: "hidden",
              flexDirection: "column",
            }}
          >
            <Routes location={routesLocation}>{tabRouteElements}</Routes>
          </Box>
        );
      })}
    </Box>
  );
};

export default React.memo(TabContent);
